import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import LazyImage from "../components/LazyImage";

export default function Companies() {
    const [companies, setCompanies] = useState([]);
    const [counts, setCounts] = useState({});
    useEffect(() => {
        (async () => {
            const r = await api.get("/companies");
            setCompanies(r.data || []);
            const counts = {};
            await Promise.all((r.data || []).map(async (c) => {
                const pr = await api.get("/projects", { params: { company: c.slug, limit: 1 } });
                counts[c.id] = pr.data.total || 0;
                const sample = await api.get("/projects", { params: { company: c.slug, limit: 3 } });
                counts[`sample_${c.id}`] = sample.data.items || [];
            }));
            setCounts(counts);
        })();
    }, []);

    return (
        <main data-testid="companies-page" className="bg-black min-h-screen pt-32 pb-24">
            <div className="container-luxury">
                <div className="overline mb-4">The Houses</div>
                <h1 className="font-serif text-5xl sm:text-6xl tracking-tight mb-14 leading-[0.95]">
                    Three premium tile companies. <em className="text-gold not-italic">One curated showroom.</em>
                </h1>
                <div className="space-y-px bg-white/10">
                    {companies.map((c) => (
                        <Link
                            key={c.id}
                            to={`/explore?company=${c.slug}`}
                            data-testid={`company-row-${c.slug}`}
                            className="block bg-black hover:bg-[#0c0c0c] transition-colors duration-500 group"
                        >
                            <div className="grid grid-cols-12 items-center gap-6 p-6 md:p-10">
                                <div className="col-span-12 md:col-span-5">
                                    <div className="overline text-gold/70 mb-3">{c.location}</div>
                                    <h2 className="font-serif text-3xl md:text-5xl tracking-tight group-hover:text-gold transition-colors duration-500">{c.name}</h2>
                                    <p className="text-white/60 text-sm mt-3 max-w-md leading-relaxed">{c.description}</p>
                                    <div className="mt-4 text-xs tracking-[0.3em] uppercase text-white/45">{counts[c.id] ?? "—"} projects</div>
                                </div>
                                <div className="col-span-12 md:col-span-7 grid grid-cols-3 gap-3">
                                    {(counts[`sample_${c.id}`] || []).map((p) => (
                                        <div key={p.id} className="aspect-[4/5] overflow-hidden">
                                            <LazyImage src={p.thumbnail_url} className="w-full h-full" />
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </Link>
                    ))}
                </div>
            </div>
        </main>
    );
}
